export default {
  ERROR_GETTING_REMINDER_NOTIFICATIONS: "There was an error getting notifications.",

  ERROR_GETTING_REMINDER_NOTIFICATIONS_COUNT: "There was an error getting notifications count.",

  ERROR_TOGGLING_NOTIFICATION_VIEWED: "There was an error toggling notification viewed.",

  ERROR_GETTING_PLATFORM_SERVICES: "There was an error getting platform services.",
};
